// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const morelull: PokeData = {
  "id": 755,
  "name": "morelull",
  "height": 2,
  "weight": 15,
  "base_experience": 57,
  "types": [
    PokeType.GRASS,
    PokeType.FAIRY
  ],
  "api_moves": [
    "absorb",
    "mega-drain",
    "sleep-powder",
    "confuse-ray",
    "dream-eater",
    "spore",
    "flash",
    "giga-drain",
    "moonlight",
    "ingrain",
    "astonish",
    "moonblast",
    "dazzling-gleam",
    "strength-sap",
    "spotlight"
  ],
  "moves": [
    "confuse-ray",
    "moonlight",
    "moonblast",
    "dazzling-gleam",
    "wood-hammer",
    "overgrowth",
    "power-whip",
    "flower-rush",
    "mist-terrain",
    "play-rough",
    "sweet-kiss",
    "vine-whip",
    "starfall"
  ],
  "evolution_chain": {
    "id": 389,
    "item": null,
    "species": [
      {
        "name": "morelull",
        "order": 755,
        "types": [
          PokeType.GRASS,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "shiinotic",
        "order": 756,
        "types": [
          PokeType.GRASS,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 755,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 24,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 52.5,
    "speed": 15,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
